import {
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { useLocation } from "react-router-dom";
import api from "../../../utils/Url";

type Props = {};

const FileDetailEdit = (props: Props) => {

    const { i18n, t } = useTranslation();
   


    const [TypeOption, setTypeOption] = useState<any>([{ value: "-1", label: t("text.SelectFileType") }]);
    const [GroupOption, setGroupOption] = useState<any>([{ value: "-1", label: t("text.SelectFileGroup") }]);
    const [CategoryOption, setCategoryOption] = useState<any>([{ value: "-1", label: t("text.SelectFileCategory") }]);
    const [ClassOption, setClassOption] = useState<any>([{ value: "-1", label:  t("text.SelectFileClass") }]);
    const [SubjectOption, setSubjectOption] = useState<any>([{ value: "-1", label:  t("text.SelectFileSubject") }]);


    useEffect(() => {
        getFileType();
        getFileGroup();
        getCategory();
        getFileCla();
        getFileSub();


    }, [])

    const getFileType = () => {
        const collectData = {
            fileTypeId: -1,
        };
        api
            .post( `FileType/GetFileType`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileTypeName,
                    value: item.fileTypeId
                }));
                setTypeOption(arr);
            })

    };

    const getFileGroup = () => {
        const collectData = {
            fileGroupid: -1,
        };
        api
            .post( `FileGroup/GetFileGroup`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileGroupName,
                    value: item.fileGroupid
                }));
                setGroupOption(arr);
            })

    };

    const getCategory = () => {
        const collectData = {
            fileCatid: -1,
        };
        api
            .post(`FileCategory/GetFileCategory`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileCatDesc,
                    value: item.fileCatid
                }));
                setCategoryOption(arr);
            })

    };


    const getFileCla = () => {
        const collectData = {
            fileClassid: -1,
        };
        api
            .post( `FileClass/GetFileClass`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.classDescription,
                    value: item.fileClassid
                }));
                setClassOption(arr);
            })

    };

    const getFileSub = () => {
        const collectData = {
            id: -1,
        };
        api
            .post( `FileSubject/GetFileSubject`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileSubjectName,
                    value: item.id
                }));
                setSubjectOption(arr);
            })

    };

    console.log()
    let navigate = useNavigate();
   

    const [toaster, setToaster] = useState(false);
    const location = useLocation();
    console.log('location', location.state)



    const validationSchema = Yup.object({

        fileName: Yup.string().test(
            'required',
            " Employee Name Required",
            function (value: any) {
                return value && value.trim() !== '';
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            fileID: location.state.fileID,
            fileName: location.state.fileName,
            synopsis: location.state.synopsis,
            remark: location.state.remark,
            refID: location.state.refID,
            totalPages: location.state.totalPages,
            fromPage: location.state.fromPage,
            toPage: location.state.toPage,
            status: location.state.status,
            rfid: location.state.rfid,
            createdBy: location.state.createdBy,
            updatedBy: location.state.updatedBy,

            fileType: location.state.fileType,
            fileGroup: location.state.fileGroup,
            fileCategory: location.state.fileCategory,
            fileClass: location.state.fileClass,
            fileSubject: location.state.fileSubject,
            sortOrder: location.state.sortOrder,
            isActive: location.state.isActive,
            user_ID: location.state.user_ID,

        },



        validationSchema: validationSchema,
        onSubmit: async (values) => {
            const response = await api.post(
                 `FileDetail/AddUpdateFileDetails`,
                values
            );
            if (response.data.isSuccess) {
                setToaster(false);
                toast.success(response.data.mesg);
                navigate('/Library/FileDetail');
            } else {
                setToaster(true);
                toast.error(response.data.mesg);

            }

        }
    });

    const requiredFields = ['fileName'];

    const back = useNavigate();

    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh"
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        File Details Edit
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>
                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="fileName"
                                    name="fileName"
                                    label={
                                        <span>
                                            Enter File Name{requiredFields.includes('fileName') && (
                                                <span style={{ color: formik.values.fileName ? 'green' : 'red' }}>*</span>
                                            )}
                                        </span>
                                    }
                                    value={formik.values.fileName}
                                    placeholder="Enter File Name"
                                    size="small"
                                    fullWidth
                                    style={{
                                        backgroundColor: 'white',
                                        borderColor: formik.touched.fileName && formik.errors.fileName ? 'red' : 'initial',
                                    }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.fileName && formik.errors.fileName ? (
                                    <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.fileName)}</div>
                                ) : null}
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="synopsis"
                                    name="synopsis"
                                    label="Synopsis"
                                    value={formik.values.synopsis}
                                    placeholder="Synopsis"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="refID"
                                    name="refID"
                                    label="Ref Id"
                                    value={formik.values.refID}
                                    placeholder="Ref Id"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="totalPages"
                                    name="totalPages"
                                    label="Total Pages"
                                    value={formik.values.totalPages}
                                    placeholder="Total Pages"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="fromPage"
                                    name="fromPage"
                                    label="From Page"
                                    value={formik.values.fromPage}
                                    placeholder="From Page"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="toPage"
                                    name="toPage"
                                    label="To Page"
                                    value={formik.values.toPage}
                                    placeholder="To Page"
                                    size="small"
                                    type="number"
                                    inputProps={{ maxLength: 10 }}
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="status"
                                    name="status"
                                    label="Status"
                                    value={formik.values.status}
                                    placeholder=" Status"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="rfid"
                                    name="rfid"
                                    label="Rf ID"
                                    value={formik.values.rfid}
                                    placeholder="Rf ID"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    id="createdBy"
                                    name="createdBy"
                                    label="Created By"
                                    value={formik.values.createdBy}
                                    placeholder="Created By"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid> */}

                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    id="updatedBy"
                                    name="updatedBy"
                                    label="Updated By"
                                    value={formik.values.updatedBy}
                                    placeholder="Updated By"
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    type="text"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid> */}


                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="remark"
                                    name="remark"
                                    label="Enter Remark "
                                    value={formik.values.remark}
                                    placeholder="Enter Remark"
                                    inputProps={{}}
                                    size="small"
                                    type="text"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={TypeOption}
                                    value={
                                        TypeOption.find(
                                            (option:any) => option.value === formik.values.fileType
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);
                                        formik.setFieldValue("fileType", newValue?.value);
                                        formik.setFieldTouched("fileType", true);
                                        formik.setFieldTouched("fileType", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectFileType")} {""}
                                                {requiredFields.includes('fileType') && (
                                                    <span style={{ color: formik.values.fileType ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.fileType && formik.errors.fileType ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.fileType)}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={GroupOption}
                                    value={
                                        GroupOption.find(
                                            (option:any) => option.value === formik.values.fileGroup
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);


                                        formik.setFieldValue("fileGroup", newValue?.value);
                                        formik.setFieldTouched("fileGroup", true);
                                        formik.setFieldTouched("fileGroup", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectFileGroup")} {""}
                                                {requiredFields.includes('fileGroup') && (
                                                    <span style={{ color: formik.values.fileGroup ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.fileGroup && formik.errors.fileGroup ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.fileGroup)}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={CategoryOption}
                                    value={
                                        CategoryOption.find(
                                            (option:any) => option.value === formik.values.fileCategory
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);
                                        formik.setFieldValue("fileCategory", newValue?.value);
                                        formik.setFieldTouched("fileCategory", true);
                                        formik.setFieldTouched("fileCategory", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectFileCategory")} {""}
                                                {requiredFields.includes('fileCategory') && (
                                                    <span style={{ color: formik.values.fileCategory ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.fileCategory && formik.errors.fileCategory ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.fileCategory)}
                                    </div>
                                ) : null}
                            </Grid>


                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={ClassOption}
                                    value={
                                        ClassOption.find(
                                            (option:any) => option.value === formik.values.fileClass
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);
                                        formik.setFieldValue("fileClass", newValue?.value);
                                        formik.setFieldTouched("fileClass", true);
                                        formik.setFieldTouched("fileClass", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectFileClass")} {""}
                                                {requiredFields.includes('fileClass') && (
                                                    <span style={{ color: formik.values.fileClass ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.fileClass && formik.errors.fileClass ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.fileClass)}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item xs={4} spacing={3}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={SubjectOption}
                                    value={
                                        SubjectOption.find(
                                            (option:any) => option.value === formik.values.fileSubject
                                        ) || null
                                    }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);

                                        formik.setFieldValue("fileSubject", newValue?.value);
                                        formik.setFieldTouched("fileSubject", true);
                                        formik.setFieldTouched("fileSubject", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectFileSubject")} {""}
                                                {requiredFields.includes('fileSubject') && (
                                                    <span style={{ color: formik.values.fileSubject ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.fileSubject && formik.errors.fileSubject ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {String(formik.errors.fileSubject)}
                                    </div>
                                ) : null}
                            </Grid>




                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#059669",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>

                </CardContent>
            </div>
        </div>
    );
};

export default FileDetailEdit;